import { tVariants } from '../../style-system';

const popoverStyles = tVariants({
    base: 'rounded-xl bg-surface border border-surface-divider relative z-[0] shadow-2xl',
});

export { popoverStyles };
